module.exports = __webpack_public_path__ + "media/country_flags/hr-9fd7b1d6.png";